import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useFormulationReview');

    return {
        AGRIAN_UNAVAILABLE: t('agrianUnavailable'),
        FORBIDDEN: t('forbidden'),
        NOT_FOUND: t('notFound'),
        RATE_LIMITED: t('rateLimited'),
        UNAVAILABLE: t('unavailable')
    };
};

export default useTranslation;
